export default function FoyerInfoBackground({children, style}) {
    return (
        <div className={`${style} mx-4 bg-black-rgba-bg backdrop-filter backdrop-blur-[12px] rounded-2xl`}>
            {children}
        </div>
    )
}